import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getConfig(officeId) {
  return request({
    url: URL.sys.financialArchivingConfig,
    method: 'get',
    params: { officeId }
  })
}

export function getArchivingConfig(officeId) {
  return request({
    url: URL.sys.getArchivingConfig,
    method: 'get',
    params: { officeId }
  })
}

export function getEffectConfig(officeId) {
  return request({
    url: URL.sys.getEffectConfig,
    method: 'get',
    params: { officeId }
  })
}

export function saveConfig(data) {
  return request({
    url: URL.sys.financialArchivingConfig,
    method: 'post',
    data
  })
}
